import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/leads").then((r) => setLeads(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/leads/${id}/read`);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await api.delete(`/leads/${id}`);
    toast.success("Deleted.");
    setSelected(null);
    load();
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-leads-page">
      <div className="border-b border-borderWarm pb-6 mb-10">
        <p className="text-[10px] uppercase tracking-[0.3em] text-muteInk">— Inbox</p>
        <h1 className="font-serif text-4xl md:text-5xl text-ink mt-2 tracking-tight">Leads <span className="italic text-clay text-2xl align-top">({leads.length})</span></h1>
      </div>

      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5 border border-borderWarm">
          {leads.length === 0 && <div className="px-6 py-10 text-center text-muteInk">No leads yet.</div>}
          {leads.map((l) => (
            <button
              key={l.id}
              onClick={() => { setSelected(l); if (!l.read) markRead(l.id); }}
              data-testid={`lead-row-${l.id}`}
              className={`w-full text-left px-5 py-4 border-b border-borderWarm hover:bg-stone2/30 ${selected?.id === l.id ? "bg-stone2/40" : ""}`}
            >
              <div className="flex items-center justify-between">
                <p className={`font-serif text-lg text-ink ${!l.read ? "font-semibold" : ""}`}>{l.name}</p>
                {!l.read && <span className="text-[9px] uppercase tracking-[0.28em] text-clay">New</span>}
              </div>
              <p className="text-[11px] uppercase tracking-[0.22em] text-muteInk mt-1">
                {l.project_type || "—"} · {new Date(l.created_at).toLocaleDateString()}
              </p>
              <p className="text-sm text-ink/70 mt-2 line-clamp-1">{l.message}</p>
            </button>
          ))}
        </div>

        <div className="col-span-12 md:col-span-7">
          {!selected ? (
            <div className="border border-dashed border-borderWarm p-16 text-center text-muteInk uppercase tracking-[0.24em] text-xs">
              Select a lead to read
            </div>
          ) : (
            <div className="border border-borderWarm p-8">
              <p className="text-[10px] uppercase tracking-[0.3em] text-muteInk">— Note</p>
              <h3 className="font-serif text-3xl text-ink mt-3">{selected.name}</h3>
              <p className="text-[12px] uppercase tracking-[0.22em] text-clay mt-1">{selected.project_type || "Type not specified"}</p>
              <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-[10px] uppercase tracking-[0.28em] text-muteInk">Email</p>
                  <p className="text-ink mt-1"><a href={`mailto:${selected.email}`} className="editorial-link">{selected.email}</a></p>
                </div>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.28em] text-muteInk">Phone</p>
                  <p className="text-ink mt-1">{selected.phone || "—"}</p>
                </div>
              </div>
              <p className="mt-8 text-[10px] uppercase tracking-[0.28em] text-muteInk">Message</p>
              <p className="font-serif text-xl text-ink leading-snug mt-3">{selected.message}</p>
              <p className="mt-8 text-[11px] uppercase tracking-[0.24em] text-muteInk">
                Received {new Date(selected.created_at).toLocaleString()}
              </p>
              <div className="mt-6 flex gap-3">
                <button onClick={() => del(selected.id)} data-testid="lead-delete" className="border border-ink px-5 py-2.5 text-[11px] uppercase tracking-[0.22em] hover:bg-ink hover:text-bone transition-colors duration-300">Delete</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
